export const COLORS = {
  blue: "#0177a9",
  white: "#ffffff",
  darkBlue: "#171e3c",
  lightBlue: "#454b63",
  gray: "#f9f9f9",
  backgroundGray: "#d9d9d9",
  backgroundGray2: "#f2f4f8",
  coral: "#38dcf5",
  green: "#008a5c",
  red: "#cd201f",
  black: "#000000",
  linearBackgroundLightBlue: "#017baf",
  linearBackgroundDarkBlue: "#012e4b",
  storesBackgroundLightBlue: "#0072ab",
  storesBackgroundDarkBlue: "#012d4a",
  boxButtonHover: "#fafbfb",
  paginationButtonBorder: "#8a8ea9",
  pilotBackground: "#989898",
};
